import type { ConstantLengthArray } from '~/utils/types';
import type { CompositeAggKeys, SearchIndex } from '../type/api';
import type { SearchListKeys } from '../type/filter-state';

interface SearchCategoryConfig {
    children: string;
    mobileName?: string;
    category?: 'products' | 'projects' | 'professionals' | 'articles';
    index?: SearchIndex;
    categoryLink?: string;
}

export const SEARCH_CATEGORIES: ConstantLengthArray<SearchCategoryConfig, 5> = [
    {
        children: 'All',
        categoryLink: undefined,
    },
    {
        children: 'Products',
        category: 'products',
        index: 'product',
        categoryLink: '/products',
    },
    {
        children: 'Projects',
        category: 'projects',
        index: 'project',
        categoryLink: '/projects',
    },
    {
        children: 'Professionals',
        mobileName: 'Pros',
        category: 'professionals',
        index: 'professional',
        categoryLink: '/professionals',
    },
    {
        children: 'Articles',
        category: 'articles',
        index: 'blogpost',
        categoryLink: '/articles',
    },
];

export const SEARCH_LIST_AGG_PARAM_KEY_MAP: Record<
    SearchListKeys,
    CompositeAggKeys
> = {
    professionals: 'aggProfessionals',
    materials: 'aggProductMaterials',
    professions: 'aggProfessions',
    libraryRanges: 'aggLibraryRanges',
    associations: 'aggAssociations',
    designers: 'aggDesigners',
    brands: 'aggBrands',
    professionalCategories: 'aggProfessionalCategories',
    downloads: 'aggDownloads',
};

export const SEARCH_QUERY_KEY = 'search';

export const LOCATION_SEARCH_PARAM_KEYS = {
    suburb: 'suburb',
    district: 'district',
    city: 'city',
    region: 'region',
    state: 'location-state',
    country: 'country',
    slug: 'location',
};
